import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette:{
        primary:{
            main: "#1760a5"
        }
    }
})